import RawData from "./RawData.vue";
export default RawData;

